import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AutoFocusModule } from 'primeng/autofocus';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

import { BaseComponent } from 'src/app/@shared/components/abstract/base.component';
import { OrganizationCardComponent } from '../organization-card/organization-card.component';
import { AddOrganizationCardComponent } from '../add-organization-card/add-organization-card.component';
import { Client } from 'src/app/@shared/models/client/client.model';

@Component({
    selector: 'app-organizations-list',
    imports: [
        CommonModule,
        FormsModule,
        AutoFocusModule,
        IconFieldModule,
        InputIconModule,
        InputTextModule,
        ProgressSpinnerModule,
        OrganizationCardComponent,
        AddOrganizationCardComponent
    ],
    templateUrl: './organizations-list.component.html',
    styleUrls: ['./organizations-list.component.scss']
})
export class OrganizationsListComponent extends BaseComponent {

    /*----------------------------------------------------------------------------------------
     * Gestion de la vue
     ----------------------------------------------------------------------------------------*/

    @Input()
    public accountantMode: boolean = false;
    @Input()
    public showAddClient: boolean = false;

    @Output() addOrganizationClicked = new EventEmitter<void>();
    @Output() activationClicked = new EventEmitter<Client>();
    @Output() organizationSelected = new EventEmitter<Client>();

    public searchQuery: string = '';

    /*----------------------------------------------------------------------------------------
     * Données
     ----------------------------------------------------------------------------------------*/

    private _clients: Client[] = [];
    public get clients(): Client[] {
        return this._clients;
    }
    @Input()
    public set clients(clients: Client[]) {
        let emptyArray: Client[] = [];
        this._clients = emptyArray.concat(clients);
    }

    /*----------------------------------------------------------------------------------------
     * Accesseurs
     ----------------------------------------------------------------------------------------*/

    public get filteredClients(): Client[] {
        if (!this.searchQuery) {
            return this.clients;
        }
        const query = this.searchQuery.toLowerCase();
        return this.clients.filter(client =>
            client.commercialName.toLowerCase().includes(query) ||
            client.name.toLowerCase().includes(query)
        );
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes publiques
     ----------------------------------------------------------------------------------------*/

    public onActivationClicked(client: Client): void {
        this.activationClicked.emit(client);
    }

    public onOrganizationClick(client: Client): void {
        this.organizationSelected.emit(client);
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes protégées
     ----------------------------------------------------------------------------------------*/

    /*----------------------------------------------------------------------------------------
     * Méthodes privées
     ----------------------------------------------------------------------------------------*/

}
